import { screenReaderContainerStyles } from '../../../../utils';
export var chatMessageReadStatusStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return {
      color: v.color,
      display: 'flex',
      position: 'absolute',
      right: v.rightPosition,
      bottom: p.density === 'compact' ? v.bottomPositionCompact : v.bottomPosition,
      ':after': Object.assign({
        content: "\"" + p.title + "\""
      }, screenReaderContainerStyles)
    };
  }
};